<template>
    <top-banner :depthTitle="depthTitle" :imgUrl="imgUrl" :firstTitle="firstTitle" :lastTitle="lastTitle" :breadCate="breadCate"></top-banner>
    <about-menu :isCurrent='isCurrent'></about-menu>
    <div class="ListSec">
      <div class="site-container">
          <h3 class="PageTitle">연구원</h3>
          <list-post :pagePost="pagePost"></list-post>
          <list-paging :totalPageCount="totalPageCount" @firstUpdate="firstPage" @itemUpdate="itemPage" @prevUpdate="prevPage" @nextUpdate="nextPage" @lastUpdate="lastPage" :currentPage="currentPage"></list-paging>
      </div>
    </div>
  </template>
  <script>
  import {computed, reactive } from 'vue'
  import { useHead } from '@vueuse/head'
  import TopBanner from "../components/topbanner/topbanner.vue";
  import ListPost from "../components/researcherpost/researcherpost.vue";
  import ListPaging from "../components/paging/paging.vue";
  import AboutMenu from "../components/aboutmenu/aboutmenu.vue";

  export default {
    name:'Researcher',
    setup() {
        const siteData = reactive({
        title: `연구원 - WithYou 위드유치료교육연구소`,
        description: 'WithYou 위드유치료교육연구소 연구원을 소개합니다.',
        canonical: 'https://withyoulove.co.kr/About/Researcher',
        })
        useHead({
            title: computed(() => siteData.title),
            meta: [
                    {
                        name: `description`,
                        content: computed(() => siteData.description),
                    },
            ],
            link: [
                {
                    rel: `canonical`,
                    content: computed(() => siteData.canonical),
                },
            ]
        })
    },
    components: {
      TopBanner,
      ListPost,
      ListPaging,
      AboutMenu,
    },
    data() {
          return {
             //상단 배너 컨텐츠
              depthTitle:'연구소 소개',
              imgUrl:'../../images/view/topbanner/topbanner-re.png',
              firstTitle:"연구소 소개",
              lastTitle:'연구원',
              breadCate:'About',

              //서브메뉴
                isCurrent:'3',
  
              //리스트
              pagePost:[],
  
              //리스트 세팅 정보
              apiUrl: 'https://withyoulove.co.kr:8000/api/teacherList/',
              queryOptions: {
                  per_page: 1,
                  cat:5
              },

              //페이징
              totalPageCount:null,
              currentPage:1
          };
      },
      mounted() {
          if(this.$route.query.page){
              this.page = this.$route.query.page;
              this.queryOptions.per_page = this.page;
          }
          //js/common.js 호출
          this.more('paging');
      },
      unmounted() {
            document.querySelector('html').classList.remove('is-Hidden');
        },
      methods:{
        itemPage:function(index){
            this.index = index;
            this.getPaging(index);
        },
        firstPage:function(index){
            this.index = index;
            this.index = 1
            this.getPaging(index);
        },
        prevPage:function(index){
            this.index = index;
            this.index--
            this.getPaging(index);
        },
        nextPage:function(index){
            this.index = index;
            this.index++
            this.getPaging(index);
        },
        lastPage:function(index){
            this.index = index;
            this.index = this.totalPageCount
            this.getPaging(index);
        },
      }
  }
  </script>
  